
<div>
  <PoppinsAlertBanner :status="alertStatus" class="mt-0 sm:mt-32 lg:mt-0" style="width: 100%">
    <p v-if="emailError" id="submit-error-email">
      This email is already associated with an account. Try
      <a href="/login" target="_blank">logging in</a> or contact
      <a href="https://support.sittercity.com/hc/en-us/requests/new" target="_blank">Customer Success</a>
    </p>
    <p v-else id="submit-error-generic">
      Something went wrong. Try reloading or contact
      <a href="https://support.sittercity.com/hc/en-us/requests/new" target="_blank">Customer Success</a>
    </p>
  </PoppinsAlertBanner>
</div>
